<template>
  <div class="video-carousel">
    <b-container fluid id="testimonial-thumbs" class="thumbnails">
      <b-container>
        <b-row class="h-100 pb-3">
          <b-col ref="bcol">
            <VueSlickCarousel v-bind="settings" ref="carousel" @afterChange="onSlideChangeHandle" >
              
              <div v-for="(video, index) in videos" :key="index" class="w-100 px-3 videos-section">
                <lazy-component>
                <BEmbed
                  type="iframe"
                  aspect="16by9"
                  :poster="require(`@/assets/img/video-thumbnails/${video.video_thumbnail}`)"
                  :src="video.video_url"
                  allowfullscreen="true"
                ></BEmbed>
               
               <!-- <iframe id="myvideo" class="ftcytvideo" width="520" height="315"  :data-src="video.video_url" frameborder="0" allowfullscreen>
                </iframe> -->
                <div class="para">
                <p class="description" v-for="(description, index) in video.video_description" :key="index" >{{description}}</p>
                </div>
                 </lazy-component>
              </div>
              
               
            </VueSlickCarousel>
          </b-col>
        </b-row>
        <b-row class="controls">
          <div id="prev-btn">
            <a @click="clickPrev">
              <svg
                class="bi bi-arrow-left-circle prev-next-slide"
                width="1.5em"
                height="1.5em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  fill-rule="evenodd"
                  d="M8.354 11.354a.5.5 0 0 0 0-.708L5.707 8l2.647-2.646a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708 0z"
                />
                <path
                  fill-rule="evenodd"
                  d="M11.5 8a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5z"
                />
              </svg>
            </a>
          </div>
          <b-col id="progress-btn" md="3" sm="2">
            <b-progress :value="sliderPercent" height="0.25rem" variant="danger"></b-progress>
          </b-col>

          <div id="next-btn">
            <a @click="clickNext">
              <svg
                class="bi bi-arrow-right-circle prev-next-slide"
                width="1.5em"
                height="1.5em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  fill-rule="evenodd"
                  d="M7.646 11.354a.5.5 0 0 1 0-.708L10.293 8 7.646 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0z"
                />
                <path
                  fill-rule="evenodd"
                  d="M4.5 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5z"
                />
              </svg>
            </a>
          </div>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { BEmbed } from 'bootstrap-vue'
//const BEmbed = () => {require('bootstrap-vue').BEmbed}
//Vue.component('b-embed', BEmbed)
export default {
  name: "Videocarousel",
  props: ["videos"],
  components: {
    VueSlickCarousel,
    BEmbed 
  },
  data() {
    return {
      value: 50,
      totalSlides: 0,
      currentSlideNo: 0,
      sliderPercent: 0,

      settings: {
        autoplay: false,
        cssEase: "ease",
        arrows: false,
        lazyLoad: "ondemand",
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  created(){
   //this.deferJs();
   window.addEventListener("load", this.onWindowLoad);
  },
  mounted(){
   
  
  
  },
  
  beforeUpdate(){
    //this.deferJs();
  },
  updated(){
    // this.deferJs();
     // document.getElementById('myvideo').src = 'https://www.youtube.com/embed/PgcokT0AWHo';
  },
  beforeDestroy() {
        window.removeEventListener('load', this.onWindowLoad);
    },
  methods: {
    onWindowLoad(){
      //this.deferJs();
    },
    onSlideChangeHandle(index) {
      this.currentSlideNo = index + 1;
      this.totalSlides = this.$props.videos.length;
      this.sliderPercent = (this.currentSlideNo / this.totalSlides) * 100;
    
      //var keyName=index+2;
     // this.vidDeferLazy(keyName);
    },
    clickPrev() {
      this.value = this.value - 1;
      this.$refs.carousel.prev();
    },
    clickNext() {
      this.value = this.value + 1;
      this.$refs.carousel.next();
    },
    deferJs() {
      var vidDefer = document.getElementsByTagName('iframe');
      //var YoutubeIDs = document.getElementsByClassName('ftcytvideo');
      
      for (var i=0; i<vidDefer.length; i++) {
        if(!vidDefer[i].hasAttribute("src")){
          if(vidDefer[i].getAttribute('data-src')) {
         // document.getElementById('ytvideo-'+[i]).src = document.getElementById('ytvideo-'+[i]).data-src;
          vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
        } 
     } 
    }
    },
    
  },

};
</script>
<style scoped>
.videos-section:focus {
  outline: none;
}
.prev-next-slide {
  color: white;
  font-size: 1.5rem;
}
.prev-next-slide:hover {
  background: var(--mainRedColor);
  color: var(--mainWhiteColor);
  border-radius: 50%;
}
.controls {
  margin-left: 3rem;
  margin-right: 3rem;
  margin-top: 2rem;
  text-align: center;
  justify-content: center;
}
.progress {
  margin-top: 1rem;
}
.description{
  color:var(--mainWhiteColor);
  margin-bottom:0;
  margin-top:0.3rem;
}
.para{
 margin-top:1rem;
}

@media (max-width: 767px) {
  #progress-btn {
    display: none;
    margin: 0;
    padding: 0;
  }
  #prev-btn,
  #next-btn {
    display: inline-block;
    margin-right: 5px;
  }
  .description{
    font-size:0.75rem;
  }
}
</style>